import { markEegStartup } from "./eegStartupTelemetry";

let prefetchStarted = false;

/**
 * Prefetch the EEG viewer route chunk on user intent (hover/focus) or from
 * study navigation. Skips when already on a direct EEG route.
 */
export function prefetchEEGViewerRoute(): void {
  if (prefetchStarted || typeof window === "undefined") return;
  if (window.location.pathname.startsWith("/eeg/")) return;

  prefetchStarted = true;
  markEegStartup("viewerRoutePrefetchStarted");

  void import("../pages/EEGViewerPage").then(() => {
    markEegStartup("viewerRoutePrefetchCompleted");
  });
}

export const eegViewerIntentHandlers = {
  onMouseEnter: prefetchEEGViewerRoute,
  onFocus: prefetchEEGViewerRoute,
};
